export const getters = {
    list: state => state.list,
    columns: state => state.columns,
    model: state => state.model,
    filter: state => state.filter,
    pagination: state => state.pagination,
    sort: state => state.sort,
    rules: state => state.rules,
    current_user_id: state => state.current_user_id
};
